import React, { FC } from 'react';
import classNames from 'classnames';
import s from '#modules/profileSelection/profilelist/add-button/addProfileButton.module.scss';
import useTranslation from 'next-translate/useTranslation';
import ProfileItemLabel from '#modules/profileSelection/profilelist/profile-item/ProfileItemLabel';

type Props = {
  onClick?: () => void;
};

const AddProfileButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  const blockClass = classNames(s.host, s.addUser);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus
    <div className={blockClass} role="button" onClick={onClick}>
      <span className={s.addIcon} />
      <ProfileItemLabel label={t('addUser')} />
    </div>
  );
};

export default AddProfileButton;
